import { render, staticRenderFns } from "./CheckBoxGroupView.vue?vue&type=template&id=01187138"
import script from "./CheckBoxGroupView.vue?vue&type=script&lang=js"
export * from "./CheckBoxGroupView.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxGroupView.vue?vue&type=style&index=0&id=01187138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports